<template>
  <div>
    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="Volunteers with skill"
      selectedOptionsHeading="Volunteers who prefer this workgroup" :initial-skills="availableAllUsers" :showDefaultMessage="false"
      v-model:interests="currentPreferedUsers" :onSave="handleSaveActivities" :loading="loading" :isSaving="submitting" />
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";

const store = useStore();
const route = useRoute();
const toast = useToast();
const loading = ref(false);
const submitting = ref(false);

const workgroupId = route.params.workgroupid;

// ✅ Reactive state
const availableAllUsers = ref([]); // all volunteers
const currentPreferedUsers = ref([]); // persons with this skill

const preferredPersons = computed(() => store.getters.preferredPersons);

// ✅ Load volunteers for this skill
const loadPreferredPersons = async () => {
  try {
    await store.dispatch("fetchPreferredPersons", workgroupId);

    availableAllUsers.value = preferredPersons.value.skilled_persons.map((v) => ({
      id: v.personid,
      name: `${v.firstname} ${v.lastname}`,
      description: v.email || "",
    }));

    currentPreferedUsers.value = preferredPersons.value.preferred_persons.map((v) => ({
      id: v.personid,
      name: `${v.firstname} ${v.lastname}`,
      description: v.email || "",
    }));
  } catch (error) {
    console.error("Failed to load preferred persons:", error);
  }
};

// ✅ Save handler for volunteers
const handleSaveActivities = async (selected) => {
  submitting.value = true;
  try {
    const personIds = selected.map((x) => x.id);

    const result = await store.dispatch("savePreferredPersons", {
      workgroupId,
      personIds,
    });

    if (result.success) {
      toast.success('Preferred persons saved successfully!', { position: 'top-right' });
      await loadPreferredPersons();
    }
  } catch (error) {
    console.error("Failed to save preferred persons:", error);
    toast.error(`Failed to save preferred persons: ${error.message}`, { position: 'top-right' });
  } finally {
    submitting.value = false;
  }
};

onMounted(async () => {
  loading.value = true;
  try {
    await loadPreferredPersons();
  } finally {
    loading.value = false;
  }
});
</script>